/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import {
	Container,
	Box,
	Flex,
	Text,
	Center,
	Menu,
	MenuButton,
	MenuList,
	MenuItem,
	Badge,
	useToast,
	Tooltip,
	Wrap,
	WrapItem,
	Avatar,
	Button,
	AlertDialog,
	AlertDialogOverlay,
	AlertDialogContent,
	AlertDialogHeader,
	AlertDialogBody,
	AlertDialogFooter,
	Accordion,
	AccordionItem,
	AccordionButton,
	AccordionIcon,
	AccordionPanel,
	Image,
	Divider,
	useDisclosure,
	Modal as CModal,
	Modal as NModal,
	ModalOverlay,
	ModalContent,
	ModalHeader,
	ModalFooter,
	ModalBody,
	ModalCloseButton,
	Table,
	Thead,
	Tr,
	Th,
	Tfoot,
	Tbody,
	Td,
} from '@chakra-ui/react';
import { faPrint, faMinusSquare, faPlusSquare, faEllipsisH, faEdit } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { gql, useLazyQuery, useMutation } from '@apollo/client';
import { useLocation } from 'react-router-dom';
import { CheckIcon, WarningIcon, RepeatIcon, SpinnerIcon } from '@chakra-ui/icons';
import BreadcrumbComponent from '../../components/BreadcrumbComponent/BreadcrumbComponent';
import ViewComment from '../../components/Comment/ViewComment';
import DownloadAndViewButton from '../../components/Files/DownloadAndViewButton';
import SelectUserModal from '../../components/Modal/SelectUserModal';
import DoneFileUplaod from '../../components/complaint/DoneFileUplaod';
import UserDislayNameById from '../../components/UserDislayNameById';
import PrintLayout from '../../components/Print/PrintLayout';
import useStore from '../../store';
import moment from 'moment';
import c from '../../constant';
import './style.css';
import Modal from '../../components/form/CompanyPickerFormField/PublicModal';
import useMoment from '../../hooks/useMoment';
import LoadingOverlay from '../../components/LoadingOverlay/LoadingOverlay';
import UserReplyLetterFile from '../../components/complaint/UserReplyLetterUpload';
import ComplaintCategoryRow from '../../components/complaint/ComplaintCategoryRow';
import ContactInfoInput from '../../components/complaint/ContactInfoInput';
import ApplicantNote from '../../components/complaint/ApplicantNote';
import UploadPlaintiffInvitationLetter from '../../components/complaint/UploadPlaintiffInvitationLetter';
import UploadCompanyInvitationLetter from '../../components/complaint/UploadCompanyInvitationLetter';
const leftLabelWidth = '120px';

const QUERY_COMPLAINT = gql`
	query get($id: String!) {
		getComplaintById(id: $id) {
			id
			no
			subject
			description
			createdAt
			complaintFile
			complaintFileSize
			complaintType
			settled
			settledDate
			spam
			plaintiffReplyLetterFile
			adminComplaintStatus
			name
			phoneNumber
			withdrawReason
			plaintiffResolutionAcceptance
			resolutionDenialReason
			complaintCategories
			complaintOnCompany {
				id
				name
				nameKhmer
				logo
				url
				type
			}
			notification {
				read
			}
			assignTo {
				user {
					id
					username
					fullName
					fullNameKhmer
					avatar
				}
				createdBy
				createdAt
			}
			plaintiffReplyLetterAssigner {
				fullName
				fullNameKhmer
			}
			doneFile
			complaintFileMobile
			platform
			adminContactName
			adminContactNumber
			employeesContactInfo {
				fullName
				phoneNumber
			}
			applicantNote
			plaintiffInvitationLetter
		}
	}
`;

const QUERY_SET_AS_SPAM = gql`
	mutation setComplaintByIdAsSpam($id: String!) {
		setComplaintByIdAsSpam(id: $id)
	}
`;

const QUERY_SET_AS_NOT_SPAM = gql`
	mutation setComplaintByIdAsNotSpam($id: String!) {
		setComplaintByIdAsNotSpam(id: $id)
	}
`;

const MUTATION_ASSIGN_USER = gql`
	mutation assign($id: String!, $userId: String!) {
		assignComplaintToUser(id: $id, userId: $userId)
	}
`;

const MUTATION_REMOVE_USER = gql`
	mutation remove($id: String!, $userId: String!) {
		removeAssignedComplaintFromUser(id: $id, userId: $userId)
	}
`;

const MUTATION_SET_INPROGRESS_COMPLAINT = gql`
	mutation set($id: String!) {
		setComplaintByIdAsInprogress(id: $id)
	}
`;
const MUTATION_SET_SETTLED_COMPLAINT = gql`
	mutation set($id: String!) {
		setSettledComplaintById(id: $id)
	}
`;

const MUTATION_ASSIGN_COMPANY = gql`
	mutation set(
		$subject: String!
		$ComplaintAssignTypes: ComplaintAssignTypes!
		$status: StatusTypes!
		$complaintId: String!
		$companyId: String!
		$no: String!
		$data: JSON!
	) {
		createComplaintAssignmentRecord(
			subject: $subject
			ComplaintAssignTypes: $ComplaintAssignTypes
			status: $status
			complaintId: $complaintId
			companyId: $companyId
			no: $no
			data: $data
		)
	}
`;

const QUERY_ASSIGNED_COMPANY = gql`
	query getAssignedCompanyDetails($companyId: String!) {
		getAssigedCompanyByCompanyId(companyId: $companyId) {
			name
			nameKhmer
			logo
		}
	}
`;

const QUERY_LOAD_ASSIGNED_COMPANY = gql`
	query loadAssignedCompany($complaintId: String!) {
		getExistingAssignedCompanyByComplaintId(complaintId: $complaintId) {
			id
			companyId
			replyLetter
			status
			note
			createdAt
			firstReadAt
			dueAt
			supportingDocument
			companyInvitationLetter
		}
	}
`;

const MUTATION_REMOVE_ASSIGNED_COMPANY = gql`
	mutation removeAssignedCompany($id: String!) {
		removeAssingedComanyById(id: $id)
	}
`;

const UPDATE_STATUS = gql`
	mutation ChangeStatusById($id: String!, $status: StatusTypes!) {
		changeStatusByIdAdmin(id: $id, status: $status)
	}
`;

const SAVE_CONTACT_INFO = gql`
	mutation saveAdminContactInfo($id: String!, $adminContactName: String, $adminContactNumber: String) {
		setComplaintAdminContactInfo(id: $id, adminContactName: $adminContactName, adminContactNumber: $adminContactNumber)
	}
`;

const SAVE_APPLICANT_NAME = gql`
	mutation SaveApplicantNameOnNoteComplaint($id: String!, $name: String) {
		updateComplaintData(id: $id, name: $name)
	}
`;

function NewComplaintDetail() {
	const { t } = useTranslation();
	const location = useLocation();
	const urlParams = new URLSearchParams(location.search);
	const id = urlParams.get('id') ? urlParams.get('id') : null;
	const { currentLang } = useStore((state) => state.currentLang);
	const [loadComplaint, { error, loading, data }] = useLazyQuery(QUERY_COMPLAINT);
	const [setInprogressComplaintById, { data: setInprogressData }] = useMutation(MUTATION_SET_INPROGRESS_COMPLAINT);
	const [settledComplaintById, { data: setSettledData }] = useMutation(MUTATION_SET_SETTLED_COMPLAINT);
	const [setAsSpamComplaint, { error: errorSetAsSpam, data: dataSetAsSpam }] = useMutation(QUERY_SET_AS_SPAM);
	const [setAsNotSpamComplaint, { error: errorSetAsNotSpam, data: dataSetAsNotSpam }] = useMutation(QUERY_SET_AS_NOT_SPAM);
	const setCountUnreadNotifications = useStore((state) => state.setCountUnreadNotifications);
	const { countUnreadNotifications } = useStore((state) => state.countUnreadNotifications);
	const { currentUser } = useStore((state) => state.currentUser);
	const [selectUserModalOpen, setSelectUserModalOpen] = useState(false);
	const [isOpen, setIsOpen] = useState(false);
	const [removingUserId, setRemovingUserId] = useState(null);
	const [assignUserMutation, { error: errorAssign, data: dataAssign }] = useMutation(MUTATION_ASSIGN_USER);
	const [removeUserMutation, { error: errorRemove, loading: loadingRemove, data: dataRemove }] = useMutation(MUTATION_REMOVE_USER);
	const cancelRef = useRef();
	const onClose = () => setIsOpen(false);
	const { isOpen: companyAssignModal, onOpen: companyAssignModalOpen, onClose: companyAssignModalClose } = useDisclosure();
	const [CompanyInfo, setCompanyInfo] = useState(null);
	const [assignCompanyMutation, { data: dataAssignCompany, loading: loadingAssignCompany, error: errorAssignCompany }] = useMutation(MUTATION_ASSIGN_COMPANY);
	const [getAssignedCompanyDetails, { data: dataAssignedCompany, error: errorAssignedCompany }] = useLazyQuery(QUERY_ASSIGNED_COMPANY);
	const [loadAssignedCompany, { data: dataLoadAssignedCompany, loading: loadingLoadAssignedCompany }] = useLazyQuery(QUERY_LOAD_ASSIGNED_COMPANY);
	const [storedAssignedCompanyData, setStoredAssignedCompanyData] = useState(null);
	const [displayAddCompany, setdisplayAddCompany] = useState(false);
	const [openRemoveCompanyBox, setOpenRemoveCompanyBox] = useState(false);
	const displayRemoveCompanyBox = () => setOpenRemoveCompanyBox(true);
	const hideRemoveCompanyBox = () => setOpenRemoveCompanyBox(false);
	const [removeAssignedCompanyById, { data: dataRemoveAssignedCompany, error: errorRemoveAssignedCompany, loading: loadingRemoveAssignedCompany }] =
		useMutation(MUTATION_REMOVE_ASSIGNED_COMPANY);
	const [updateStatus, { data: dataUpdateStatus, loading: loadingUpdateStatus }] = useMutation(UPDATE_STATUS);
	const { paperSolarDateString, paperLunarDateString } = useMoment();
	const [complaintCategoryChange, setComplaintCategoryChange] = useState('');
	const [storedContactName, setStoredContactName] = useState(null);
	const [storedContactPhoneNumber, setStoredContactPhoneNumber] = useState(null);
	const [saveContactInfo, { data: contactInfoSaveData, loading: contactInfoSaveLoading }] = useMutation(SAVE_CONTACT_INFO);
	const [contactInfoModal, setContactInfoModal] = useState(false);
	const openContactInfoModal = () => setContactInfoModal(true);
	const closeContactInfoModal = () => setContactInfoModal(false);
	const [saveApplicantName, { data: dataApplicantName, loading: loadingApplicantname }] = useMutation(SAVE_APPLICANT_NAME);
	const [applicantName, setApplicantName] = useState(null);
	const [applicantNameModal, setApplicantNameModal] = useState(false);
	const openApplicantNameModal = () => setApplicantNameModal(true);
	const closeApplicantNameModal = () => setApplicantNameModal(false);
	const [assignCompanyConfirmationBox, setAssignCompanyConfirmationBox] = useState(false);
	const openAssignCompanyConfirmationBox = () => setAssignCompanyConfirmationBox(true);
	const closeAssignCompanyConfirmationBox = () => setAssignCompanyConfirmationBox(false);
	const [assginedCompnayConfirmationData, setAssginedCompnayConfirmationData] = useState(null);
	// useEffect(() => {
	// 	if (data?.getComplaintById) {
	// 		console.log('data:', data?.getComplaintById);
	// 	}
	// }, [data]);

	// useEffect(() => {
	// 	if (dataLoadAssignedCompany?.getExistingAssignedCompanyByComplaintId) {
	// 		console.log('dataLoadAssignedCompany:', dataLoadAssignedCompany?.getExistingAssignedCompanyByComplaintId);
	// 	}
	// }, [dataLoadAssignedCompany]);

	useEffect(() => {
		loadComplaint({
			variables: {
				id,
			},
		});
	}, [complaintCategoryChange, contactInfoSaveData, dataApplicantName]);

	useEffect(() => {
		if (dataAssignCompany || dataLoadAssignedCompany) {
			setdisplayAddCompany(true);
		}
	}, [dataAssignCompany, dataLoadAssignedCompany]);

	useEffect(() => {
		if (dataRemoveAssignedCompany) {
			setdisplayAddCompany(false);
			toast({
				title: t('Company removed successfully'),
				status: 'success',
				isClosable: true,
				position: 'top-right',
			});
			loadComplaint({
				variables: {
					id,
				},
			});
		}
	}, [dataRemoveAssignedCompany]);

	useEffect(() => {
		if (errorRemoveAssignedCompany) {
			if (errorRemoveAssignedCompany?.graphQLErrors?.length > 0) {
				errorRemoveAssignedCompany?.graphQLErrors.map(({ message }, i) =>
					toast({
						title: t(message),
						status: 'error',
						isClosable: true,
						position: 'top-right',
					}),
				);
			} else {
				toast({
					title: t(errorRemoveAssignedCompany?.message ? errorRemoveAssignedCompany?.message : 'something went wrong'),
					status: 'error',
					isClosable: true,
					position: 'top-right',
				});
			}
		}
	}, [errorRemoveAssignedCompany]);

	useEffect(() => {
		if (errorAssignedCompany) {
			if (errorAssignedCompany?.graphQLErrors?.length > 0) {
				errorAssignedCompany?.graphQLErrors.map(({ message }, i) =>
					toast({
						title: t(message),
						status: 'error',
						isClosable: true,
						position: 'top-right',
					}),
				);
			} else {
				toast({
					title: t(errorAssignedCompany?.message ? errorAssignedCompany?.message : 'something went wrong'),
					status: 'error',
					isClosable: true,
					position: 'top-right',
				});
			}
		}
	}, [errorAssignedCompany]);

	useEffect(() => {
		if (dataLoadAssignedCompany?.getExistingAssignedCompanyByComplaintId) {
			setStoredAssignedCompanyData(dataLoadAssignedCompany?.getExistingAssignedCompanyByComplaintId);
		}
		if (dataLoadAssignedCompany?.getExistingAssignedCompanyByComplaintId?.companyId) {
			getAssignedCompanyDetails({
				variables: {
					companyId: dataLoadAssignedCompany?.getExistingAssignedCompanyByComplaintId?.companyId,
				},
			});
		}
	}, [dataLoadAssignedCompany]);

	useEffect(() => {
		if (dataAssignCompany) {
			toast({
				title: t('Company assigned successfully'),
				status: 'success',
				isClosable: true,
				position: 'top-right',
			});
			loadAssignedCompany({
				variables: {
					complaintId: id,
				},
			});
			loadComplaint({
				variables: {
					id,
				},
			});
		}
	}, [dataAssignCompany]);

	useEffect(() => {
		if (errorAssignCompany) {
			if (errorAssignCompany?.graphQLErrors?.length > 0) {
				errorAssignCompany?.graphQLErrors.map(({ message }, i) =>
					toast({
						title: t(message),
						status: 'error',
						isClosable: true,
						position: 'top-right',
					}),
				);
			} else {
				toast({
					title: t(errorAssignCompany?.message ? errorAssignCompany?.message : 'something went wrong'),
					status: 'error',
					isClosable: true,
					position: 'top-right',
				});
			}
		}
	}, [errorAssignCompany]);

	useEffect(() => {
		if (CompanyInfo?.id && id) {
			assignCompanyMutation({
				variables: {
					subject: data?.getComplaintById?.subject,
					ComplaintAssignTypes: 'OTHER_COMPLAINT',
					status: 'NEED_REPLY',
					complaintId: id,
					companyId: CompanyInfo?.id,
					no: data?.getComplaintById?.no,
					data: {
						solarDate: paperSolarDateString(),
						lunarDate: paperLunarDateString(),
					},
				},
			});
			getAssignedCompanyDetails({
				variables: {
					companyId: CompanyInfo?.id,
				},
			});
		}
	}, [CompanyInfo]);

	moment.locale(currentLang === 'kh' ? 'km' : 'en-gb');

	useEffect(() => {
		if (dataRemove?.removeAssignedComplaintFromUser) {
			toast({
				title: t('User removed successfully'),
				status: 'success',
				isClosable: true,
				position: 'top-right',
			});
			loadComplaint({
				variables: {
					id,
				},
			});
			onClose();
		}
	}, [dataRemove]);

	useEffect(() => {
		if (errorAssign) {
			if (errorAssign?.graphQLErrors?.length > 0) {
				errorAssign?.graphQLErrors.map(({ message }, i) =>
					toast({
						title: t(message),
						status: 'error',
						isClosable: true,
						position: 'top-right',
					}),
				);
			} else {
				toast({
					title: t(errorAssign?.message ? errorAssign?.message : 'something went wrong'),
					status: 'error',
					isClosable: true,
					position: 'top-right',
				});
			}
		}
	}, [errorAssign]);

	useEffect(() => {
		if (dataAssign?.assignComplaintToUser) {
			toast({
				title: t('User assigned successfully'),
				status: 'success',
				isClosable: true,
				position: 'top-right',
			});
			loadComplaint({
				variables: {
					id,
				},
			});
		}
	}, [dataAssign]);

	useEffect(async () => {
		if (setSettledData?.setSettledComplaintById) {
			toast({
				title: t('Complaint set as settled successfully'),
				status: 'success',
				isClosable: true,
				position: 'top-right',
			});
			if (storedAssignedCompanyData?.id) {
				await updateStatus({
					variables: {
						id: storedAssignedCompanyData?.id,
						status: 'SETTLED',
					},
				});
			}
			loadComplaint({
				variables: {
					id,
				},
			});
			loadAssignedCompany({
				variables: {
					complaintId: id,
				},
			});
			window.location.reload();
		}
	}, [setSettledData]);

	const toast = useToast();

	useEffect(() => {
		window.scrollTo(0, 0);
		loadComplaint({
			variables: {
				id,
			},
		});
		loadAssignedCompany({
			variables: {
				complaintId: id,
			},
		});
	}, []);

	useEffect(() => {
		if (id) {
			loadComplaint({
				variables: {
					id,
				},
			});
		}
	}, [id]);

	useEffect(() => {
		if (setInprogressData?.setComplaintByIdAsInprogress) {
			toast({
				title: t('Complaint set to in progress successfully'),
				status: 'success',
				isClosable: true,
				position: 'top-right',
			});
			loadComplaint({
				variables: {
					id,
				},
			});
		}
	}, [setInprogressData]);

	function complaintType(type) {
		return type === 'COMPLAINT' ? (
			<Badge className="hidden-print" colorScheme="purple">
				{t('Complaint')}
			</Badge>
		) : (
			<Badge className="hidden-print" colorScheme="green">
				{t('Cancel Complaint')}
			</Badge>
		);
	}

	function setSettledComplaint() {
		settledComplaintById({
			variables: {
				id,
			},
		});
	}

	function getStatus({ settled, settledDate }, adminComplaintStatus) {
		switch (adminComplaintStatus) {
			case 'IN_PROGRESS':
				return <Badge colorScheme="red">{t('In progress')}</Badge>;
			case 'WAITING_FOR_COMPANY_REPLY':
				return <Badge colorScheme="yellow">{t('Waiting for company reply')}</Badge>;
			case 'RECIEVED_COMPANY_REPLY':
				return <Badge colorScheme="teal">{t('Received company reply')}</Badge>;
			case 'PROVIDED_REPLY_LETTER_TO_APPLICANT':
				return <Badge colorScheme="purple">{t('Provided reply letter to applicant')}</Badge>;
			case 'APPLICANT_MADE_DECISION':
				return <Badge colorScheme="blue">{t('Applicant made decision')}</Badge>;
			case 'SETTLED':
				return (
					<Tooltip label={settledDate ? moment(settledDate).format('LLLL') : ''}>
						<Badge colorScheme="green">{t('Settled')}</Badge>
					</Tooltip>
				);
			case 'WITHDRAWN':
				return <Badge colorScheme="gray">{t('Withdrawn')}</Badge>;
			default:
				return <Badge colorScheme="gray">{t('old complaint')}</Badge>;
		}
	}

	function getPlaintiffReplyStatus(replyresult) {
		switch (replyresult) {
			case 'AGREE':
				return (
					<Badge ml="4" colorScheme="green">
						{t('AGREE')}
					</Badge>
				);
			case 'DISAGREE':
				return (
					<Badge ml="4" colorScheme="red">
						{t('DISAGREE')}
					</Badge>
				);
			default:
				return (
					<Badge ml="4" colorScheme="gray">
						N/A
					</Badge>
				);
		}
	}

	useEffect(() => {
		if (errorSetAsSpam) {
			toast({
				title: t('Set as spam error'),
				status: 'error',
				isClosable: true,
				position: 'top-right',
			});
		}
	}, [errorSetAsSpam]);

	useEffect(() => {
		if (errorRemove) {
			toast({
				title: t('Remove assigned user error'),
				status: 'error',
				isClosable: true,
				position: 'top-right',
			});
		}
	}, [errorRemove]);

	useEffect(() => {
		if (errorSetAsNotSpam) {
			toast({
				title: t('Set as not spam error'),
				status: 'error',
				isClosable: true,
				position: 'top-right',
			});
		}
	}, [errorSetAsNotSpam]);

	useEffect(() => {
		if (dataSetAsNotSpam?.setComplaintByIdAsNotSpam) {
			toast({
				title: t('Set as not spam successfully'),
				status: 'success',
				isClosable: true,
				position: 'top-right',
			});
			loadComplaint({
				variables: {
					id,
				},
			});
		}
	}, [dataSetAsNotSpam]);

	useEffect(() => {
		if (dataSetAsSpam?.setComplaintByIdAsSpam) {
			toast({
				title: t('Set as spam successfully'),
				status: 'success',
				isClosable: true,
				position: 'top-right',
			});
			loadComplaint({
				variables: {
					id,
				},
			});
		}
	}, [dataSetAsSpam]);

	useEffect(() => {
		if (data?.getComplaintById?.notification?.read === false) {
			setCountUnreadNotifications(countUnreadNotifications - 1);
		}
	}, [data]);

	function setSpam() {
		setAsSpamComplaint({
			variables: {
				id,
			},
		});
	}

	function setNotSpam() {
		setAsNotSpamComplaint({
			variables: {
				id,
			},
		});
	}

	function getDisplayName(user) {
		let result = user?.username;
		if (currentLang === 'kh') {
			if ((result = user?.fullNameKhmer)) {
				result = user?.fullNameKhmer;
			} else {
				if (user?.fullName) {
					result = user?.fullName;
				} else {
					result = user?.username;
				}
			}
		} else {
			if ((result = user?.fullName)) {
				result = user?.fullName;
			} else {
				if (user?.fullNameKhmer) {
					result = user?.fullNameKhmer;
				} else {
					result = user?.username;
				}
			}
		}

		return result;
	}

	function removeAssignUserDialog(user) {
		setIsOpen(true);
		setRemovingUserId(user);
	}

	function selectAssignUser(userData) {
		assignUserMutation({
			variables: {
				id: id,
				userId: userData.id,
			},
		});
	}

	function setInprogressComplaint() {
		setInprogressComplaintById({
			variables: {
				id: id,
			},
		});
	}

	function getIdForAssignedCompanyRemoval() {
		if (dataAssignCompany?.createComplaintAssignmentRecord) return dataAssignCompany?.createComplaintAssignmentRecord;
		if (dataLoadAssignedCompany?.getExistingAssignedCompanyByComplaintId?.id) return dataLoadAssignedCompany?.getExistingAssignedCompanyByComplaintId?.id;
	}

	function FileViewer({ label = null, platform = null, file = null, files = [], labelWeight = '500', p = 1, pl = 2 }) {
		return (
			<Flex justifyContent="flex-start" alignItems="center" p={p} pl={pl} pr={2} style={{ pageBreakInside: 'avoid' }} _hover={{ bg: 'gray.200' }}>
				<Text mr="2" fontWeight={labelWeight} w="120px" minW="120px">
					{t(label)}:
				</Text>

				<Box ml={2} width="200px">
					{files?.length > 0 ? (
						<>
							<Accordion allowToggle allowMultiple bg="gray.100" borderRadius={2}>
								<AccordionItem border="none">
									<AccordionButton backgroundColor="gray.100" _hover={{ backgroundColor: 'gray.100' }}>
										<Box as="span" flex="1" textAlign="left">
											<Flex justifyContent="flex-start" alignItems="center">
												<Text fontWeight="normal" fontSize="sm">
													{t('Files')}
												</Text>
												&nbsp;
												<Text fontWeight="semibold" fontSize="md">{`(${files?.length})`}</Text>
											</Flex>
										</Box>
										<AccordionIcon />
									</AccordionButton>
									<AccordionPanel>
										{files?.map((file, i) => (
											<Box key={i} mb={i === files?.length - 1 ? 0 : 2}>
												<DownloadAndViewButton url={file?.url} size={file?.size} marginLeft={0} />
											</Box>
										))}
									</AccordionPanel>
								</AccordionItem>
							</Accordion>
						</>
					) : file?.url ? (
						<DownloadAndViewButton url={file?.url} size={file?.size} marginLeft={0} />
					) : (
						<>
							<Text>N/A</Text>
						</>
					)}
				</Box>
			</Flex>
		);
	}

	function checkLastStatusCondition() {
		if (data?.getComplaintById?.adminComplaintStatus === 'SETTLED') {
			return false;
		} else if (data?.getComplaintById?.adminComplaintStatus === 'WITHDRAWN') {
			return false;
		} else {
			return true;
		}
	}

	function spamCheckTurnOffButtons() {
		if (data?.getComplaintById.spam === true) {
			return false;
		} else {
			return true;
		}
	}

	function enableApplicantReplyLetterCondition() {
		if (data?.getComplaintById?.complaintCategories === 'COMPLAINT_ON_DISPUTE_INSURANCE') {
			if (data?.getComplaintById?.applicantNote === null) {
				return true;
			} else {
				return false;
			}
		} else if (data?.getComplaintById?.complaintCategories === 'COMPLAINT_OF_DISSATISFACTION_ON_INSURANCE') {
			return false;
		} else {
			return true;
		}
	}

	function applicantResponseILButtonCondition(replyresult) {
		switch (replyresult) {
			case 'AGREE':
				return true;
			case 'DISAGREE':
				return false;
			default:
				return true;
		}
	}

	return (
		<>
			<PrintLayout>
				<>
					<Container maxW="container.xl" mt="16px" mb="16px">
						<BreadcrumbComponent
							list={[
								{
									name: 'COMPLAINT',
									path: '/complaint-type',
								},
								{
									name: 'Other Complaint',
									path: '/complaint?page=1',
								},
								{
									name: 'DETAIL',
									path: '#',
								},
							]}
						/>
						<Center mt="5">
							<Box
								w="100%"
								bg="white"
								borderRadius={c.borderRadius}
								border="1px solid #dbdbdb"
								boxShadow="0 1px 2px rgba(var(--black, #000), 0.1)"
								pb="32px"
							>
								<Flex
									justifyContent="space-between"
									alignItems="center"
									bg="#FAFAFA"
									p="16px"
									pt="8px"
									pb="8px"
									mb="0px"
									borderBottom="1px solid #dbdbdb"
								>
									<Flex alignItems="center">
										<Text fontSize="x-large" fontWeight="bold" mr="4">
											{t('Complaint Detail')}
										</Text>
										{data?.getComplaintById?.complaintType && (
											<>
												<>{complaintType(data?.getComplaintById?.complaintType)}</>
											</>
										)}
										{data?.getComplaintById?.platform === 'mobile' && (
											<Badge ml={1} colorScheme="blue">
												{t('Mobile')}
											</Badge>
										)}
										{data?.getComplaintById?.spam === true && (
											<Badge ml={1} colorScheme="red">
												{t('Spam')}
											</Badge>
										)}
									</Flex>
									<Flex className="hidden-print">
										<Button
											onClick={() => window?.print()}
											leftIcon={<FontAwesomeIcon icon={faPrint} style={{ fontSize: 16 }} />}
											colorScheme="gray"
											variant="solid"
											size="sm"
											borderRadius={c.borderRadius}
											border="1px solid #bdc3c7"
										>
											{t('Print')}
										</Button>
										{currentUser?.role === 'admin' && (
											<>
												{!error && data?.getComplaintById?.id && (
													<Menu>
														<MenuButton cursor="pointer">
															<Button
																colorScheme="gray"
																variant="solid"
																size="sm"
																borderRadius={c.borderRadius}
																border="1px solid #bdc3c7"
																ml={2}
															>
																<FontAwesomeIcon icon={faEllipsisH} style={{ fontSize: 16 }} />
															</Button>
														</MenuButton>
														<MenuList pt="4" pb="4" pl="3" pr="3" borderRadius={c.borderRadius}>
															{data?.getComplaintById?.settled === false &&
																currentUser.role === 'admin' &&
																checkLastStatusCondition() && (
																	<MenuItem color={'green'} icon={<CheckIcon />} onClick={() => setSettledComplaint()}>
																		{t('Settled')}
																	</MenuItem>
																)}
															{/* {data?.getComplaintById?.settled === true && currentUser.role === 'admin' && (
																<MenuItem icon={<SpinnerIcon />} onClick={() => setInprogressComplaint()}>
																	{t('In progress')}
																</MenuItem>
															)} */}
															{data?.getComplaintById?.spam === false && (
																<MenuItem icon={<WarningIcon />} onClick={() => setSpam()}>
																	{t('Spam')}
																</MenuItem>
															)}
															{data?.getComplaintById?.spam === true && (
																<MenuItem icon={<RepeatIcon />} onClick={() => setNotSpam()}>
																	{t('Not Spam')}
																</MenuItem>
															)}
														</MenuList>
													</Menu>
												)}
											</>
										)}
									</Flex>
								</Flex>

								{loading && (
									<Flex p={4} pb={0} justifyContent="center" alignItems="center">
										<Text>{t('Loading')}</Text>
									</Flex>
								)}

								{error && (
									<Flex p={4} pb={0} justifyContent="center" alignItems="center">
										<Text>{t(error?.message)}</Text>
									</Flex>
								)}

								{data?.getComplaintById && (
									<Box p="16px" pb="0px">
										<Flex alignItems="center" p={1} pl={2} pr={2} _hover={{ bg: 'gray.200' }}>
											<Text fontWeight="500" minW={leftLabelWidth} w={leftLabelWidth}>
												{t('Assign to')}:
											</Text>
											<Wrap ml="4">
												{data?.getComplaintById?.assignTo?.map((aTo, index) => {
													return (
														<Flex direction="column" justifyContent="center" alignItems="center" key={'u-' + index}>
															<Tooltip
																label={
																	<>
																		{t('Assign By')}&nbsp;
																		<UserDislayNameById id={aTo?.createdBy} />
																		&nbsp;{', '}&nbsp;
																		{moment(aTo.createdAt).format('LLLL')}
																	</>
																}
															>
																<WrapItem className="avatarWraper">
																	{(currentUser?.role === 'admin' || currentUser?.canAssignUserToComplaint) &&
																		currentUser?.id !== aTo?.user?.id && (
																			<FontAwesomeIcon
																				onClick={() => {
																					removeAssignUserDialog(aTo?.user);
																				}}
																				className="remove"
																				icon={faMinusSquare}
																				style={{
																					fontSize: 18,
																					display: 'none',
																					position: 'absolute',
																					zIndex: '100',
																					marginLeft: 32,
																					color: 'red',
																					backgroundColor: 'white',
																					padding: 2,
																					cursor: 'pointer',
																				}}
																			/>
																		)}
																	<Avatar
																		name={getDisplayName(aTo?.user)}
																		src={aTo?.user?.avatar?.icon ? c.baseFilePath + aTo?.user?.avatar?.icon : null}
																	/>
																</WrapItem>
															</Tooltip>
															<Text textAlign="center">{getDisplayName(aTo.user)}</Text>
														</Flex>
													);
												})}
												{(currentUser?.role === 'admin' || currentUser?.canAssignUserToComplaint) && (
													<Flex>
														<Button
															className="hidden-print"
															onClick={() => setSelectUserModalOpen(true)}
															leftIcon={<FontAwesomeIcon icon={faPlusSquare} style={{ fontSize: 18 }} />}
															colorScheme="blue"
															variant="outline"
														>
															{t('Add')}
														</Button>
													</Flex>
												)}
											</Wrap>
										</Flex>

										<Divider h="1px" mt="8" mb="8" />

										<Flex p={1} pl={2} pr={2} _hover={{ bg: 'gray.200' }}>
											<Text fontWeight="500" w="120px" minW="120px">
												{t('Number')}:
											</Text>
											<Text ml="4">{data?.getComplaintById?.no}</Text>
										</Flex>

										<ComplaintCategoryRow
											label="Complaint Category"
											complaintId={id}
											complaintType={data?.getComplaintById?.complaintCategories}
											onChange={(value) => {
												setComplaintCategoryChange(value);
											}}
											disabled={
												storedAssignedCompanyData !== null || !checkLastStatusCondition() || !spamCheckTurnOffButtons() ? true : false
											}
										/>

										<Flex p={1} pl={2} pr={2} _hover={{ bg: 'gray.200' }}>
											<Text fontWeight="500" w="120px" minW="120px">
												{t('Created At')}:
											</Text>
											<Text ml="4">{moment(data?.getComplaintById?.createdAt).format('LLLL')}</Text>
										</Flex>
										<Flex p={1} pl={2} pr={2} _hover={{ bg: 'gray.200' }}>
											<Text fontWeight="500" w="120px" minW="120px">
												{t('Status')}:
											</Text>
											<Box ml="4">
												{data?.getComplaintById?.spam === false &&
													getStatus(
														{
															settled: data?.getComplaintById?.settled,
															settledDate: data?.getComplaintById?.settledDate,
														},
														data?.getComplaintById?.adminComplaintStatus,
													)}
												{data?.getComplaintById?.spam === true && <Badge colorScheme="red">{t('Spam')}</Badge>}
											</Box>
										</Flex>
										<Flex p={1} pl={2} pr={2} _hover={{ bg: 'gray.200' }} alignItems="center">
											<Text fontWeight="500" w="120px" minW="120px">
												{t('Reason of Withdrawal')}:
											</Text>
											<Box ml="4">{data?.getComplaintById?.withdrawReason ? data?.getComplaintById?.withdrawReason : 'N/A'}</Box>
										</Flex>
										{data?.getComplaintById?.settled && (
											<>
												<Flex p={1} pl={2} pr={2} _hover={{ bg: 'gray.200' }}>
													<Text fontWeight="500" w="120px" minW="120px">
														{t('Settled at')}:
													</Text>
													<Text ml="4">{moment(data?.getComplaintById?.settledDate).format('LLL')}</Text>
												</Flex>
											</>
										)}

										<Divider h="1px" mt="8" mb="8" />

										<Flex alignItems="center" p={1} pl={2} pr={2} _hover={{ bg: 'gray.200' }}>
											<Text fontWeight="500" minW={leftLabelWidth} w={leftLabelWidth}>
												{t('Complaint on Company')}:
											</Text>
											{data?.getComplaintById.complaintOnCompany !== null ? (
												<Flex ml="4" direction="column" justifyContent="center" alignItems="center">
													<Flex justifyContent="center">
														<Image
															// maxW="70px"
															maxH="40px"
															h="auto"
															w="auto"
															src={c.baseFilePath + data?.getComplaintById.complaintOnCompany.logo}
															alt={`${data?.getComplaintById.complaintOnCompany.name} - ${data?.getComplaintById.complaintOnCompany.nameKhmer}`}
															objectFit="contain"
															fallbackSrc="/files/images/no-logo.png"
														/>
													</Flex>
													<Text textAlign="center">
														{currentLang === 'en'
															? data?.getComplaintById.complaintOnCompany.name
															: data?.getComplaintById.complaintOnCompany.nameKhmer}
													</Text>
												</Flex>
											) : (
												<Text ml="4">N/A</Text>
											)}
										</Flex>

										<Flex p={1} pl={2} pr={2} _hover={{ bg: 'gray.200' }}>
											<Text fontWeight="500" w="120px" minW="120px">
												{t('Subject')}:
											</Text>
											<Text ml="4">{data?.getComplaintById?.subject}</Text>
										</Flex>
										<Flex p={1} pl={2} pr={2} _hover={{ bg: 'gray.200' }}>
											<Text fontWeight="500" w="120px" minW="120px">
												{t('name')}:
											</Text>
											<Text ml="4" flex="1">
												{data?.getComplaintById?.name && data?.getComplaintById?.name.trim() !== ''
													? data?.getComplaintById?.name
													: 'N/A'}
											</Text>
											<FontAwesomeIcon onClick={() => openApplicantNameModal()} className="hidden-print" cursor="pointer" icon={faEdit} />
										</Flex>
										<Flex p={1} pl={2} pr={2} _hover={{ bg: 'gray.200' }}>
											<Text fontWeight="500" w="120px" minW="120px">
												{t('phoneNumber')}:
											</Text>
											{<Text ml="4">{data?.getComplaintById?.phoneNumber ? data?.getComplaintById?.phoneNumber : 'N/A'}</Text>}
										</Flex>

										{data?.getComplaintById?.description && (
											<Flex p={1} pl={2} pr={2} _hover={{ bg: 'gray.200' }}>
												<Text fontWeight="500" w="120px" minW="120px">
													{t('Details')}:
												</Text>
												<Text ml="4">{data?.getComplaintById?.description}</Text>
											</Flex>
										)}
										<Box mt={2}>
											<FileViewer
												label="File"
												platform={data?.getComplaintById?.platform}
												// file={{ file: data?.getComplaintById?.complaintFile, fileSize: data?.getComplaintById?.complaintFileSize }}
												files={data?.getComplaintById?.complaintFileMobile}
											/>
										</Box>
										<Divider h="1px" mt="8" mb="8" />

										<Flex
											justifyContent="flex-start"
											alignItems="center"
											p={1}
											pl={2}
											pr={2}
											style={{ pageBreakInside: 'avoid' }}
											_hover={{ bg: 'gray.200' }}
										>
											<Text mr="2" fontWeight="500" w="120px" minW="120px">
												{t('Officer Name')}:
											</Text>

											<Text ml="2" mr="4" flex="1">
												{data?.getComplaintById?.adminContactName && data?.getComplaintById?.adminContactName.trim() !== ''
													? data?.getComplaintById?.adminContactName
													: 'N/A'}
											</Text>
											<FontAwesomeIcon onClick={() => openContactInfoModal()} className="hidden-print" cursor="pointer" icon={faEdit} />
										</Flex>
										<Flex
											justifyContent="flex-start"
											alignItems="center"
											p={1}
											pl={2}
											pr={2}
											style={{ pageBreakInside: 'avoid' }}
											_hover={{ bg: 'gray.200' }}
										>
											<Text mr="2" fontWeight="500" w="120px" minW="120px">
												{t('Contact Phone number')}:
											</Text>

											<Text ml="2" mr="4" flex="1">
												{data?.getComplaintById?.adminContactNumber && data?.getComplaintById?.adminContactNumber.trim() !== ''
													? data?.getComplaintById?.adminContactNumber
													: 'N/A'}
											</Text>
											<FontAwesomeIcon onClick={() => openContactInfoModal()} className="hidden-print" cursor="pointer" icon={faEdit} />
										</Flex>

										<Flex alignItems="center" p={1} pl={2} pr={2} _hover={{ bg: 'gray.200' }}>
											<Text fontWeight="bold" minW={leftLabelWidth} w={leftLabelWidth}>
												{t('Assign to company')}:
											</Text>
											<Wrap ml="4">
												<Flex direction="column" justifyContent="center" alignItems="center">
													{displayAddCompany && (
														<WrapItem className="avatarWraper">
															<Box position="relative" display="inline-block">
																{storedAssignedCompanyData?.status !== 'SETTLED' &&
																	checkLastStatusCondition() &&
																	spamCheckTurnOffButtons() && (
																		<FontAwesomeIcon
																			onClick={displayRemoveCompanyBox}
																			className="remove"
																			icon={faMinusSquare}
																			style={{
																				fontSize: 18,
																				display: 'none',
																				position: 'absolute',
																				top: -6,
																				right: -4,
																				zIndex: '100',
																				marginLeft: 32,
																				color: 'red',
																				backgroundColor: 'transparent',
																				padding: 2,
																				cursor: 'pointer',
																			}}
																		/>
																	)}
																<Box>
																	<Flex justifyContent="center">
																		<Image
																			// maxW="70px"
																			maxH="40px"
																			h="auto"
																			w="auto"
																			src={c.baseFilePath + dataAssignedCompany?.getAssigedCompanyByCompanyId.logo}
																			alt={`${dataAssignedCompany?.getAssigedCompanyByCompanyId?.name} - ${dataAssignedCompany?.getAssigedCompanyByCompanyId?.nameKhmer}`}
																			objectFit="contain"
																			fallbackSrc="/files/images/no-logo.png"
																		/>
																	</Flex>
																</Box>
															</Box>
														</WrapItem>
													)}
													{displayAddCompany && (
														<Text textAlign="center">
															{currentLang === 'en'
																? dataAssignedCompany?.getAssigedCompanyByCompanyId?.name
																: dataAssignedCompany?.getAssigedCompanyByCompanyId?.nameKhmer}
														</Text>
													)}
												</Flex>
											</Wrap>
											{/* <Wrap>
												<Flex>
													{!storedAssignedCompanyData &&
														!spamCheckTurnOffButtons() &&
														(data?.getComplaintById?.settled === true || !checkLastStatusCondition()) && (
															<>
																<Text>N/A</Text>
															</>
														)}
												</Flex>
											</Wrap> */}
											<Wrap>
												{!displayAddCompany && (
													<Tooltip
														label={
															<>
																<Text color="white">
																	{data?.getComplaintById?.complaintCategories === null
																		? '•' + t('Please pick a complaint category') + '\n'
																		: ''}
																</Text>
																<Text color="white">
																	{data?.getComplaintById?.adminContactName === null ||
																	data?.getComplaintById?.adminContactNumber === null
																		? '•' + t('Please Fill in Contact Info')
																		: ''}
																</Text>
															</>
														}
													>
														<Flex>
															<Button
																disabled={
																	data?.getComplaintById?.complaintCategories === null ||
																	data?.getComplaintById?.adminContactName === null ||
																	data?.getComplaintById?.adminContactNumber === null ||
																	!checkLastStatusCondition() ||
																	!spamCheckTurnOffButtons()
																		? true
																		: false
																}
																className="hidden-print"
																onClick={companyAssignModalOpen}
																leftIcon={<FontAwesomeIcon icon={faPlusSquare} style={{ fontSize: 18 }} />}
																colorScheme="blue"
																variant="outline"
															>
																{t('Add')}
															</Button>
														</Flex>
													</Tooltip>
												)}
											</Wrap>
										</Flex>

										<Flex alignItems="center" mt="2" pr={2} _hover={{ bg: 'gray.200' }}>
											<Flex
												justifyContent="flex-start"
												alignItems="center"
												p={1}
												pl={2}
												pr={2}
												style={{ pageBreakInside: 'avoid' }}
												_hover={{ bg: 'gray.200' }}
											>
												<Text mr="2" fontWeight="bold" w="120px" minW="120px">
													{t('complaint note')}:
												</Text>
												<Box ml={2}>
													{storedAssignedCompanyData?.note ? (
														<>
															<DownloadAndViewButton url={storedAssignedCompanyData?.note.url} marginLeft={0} />
														</>
													) : (
														<>
															<Text>N/A</Text>
														</>
													)}
												</Box>
											</Flex>
										</Flex>

										<Flex p={1} pl={2} pr={2} mt="2" _hover={{ bg: 'gray.200' }}>
											<Text fontWeight="bold" w="120px" minW="120px">
												{t('sent date')}:
											</Text>
											<Text ml="4">
												{storedAssignedCompanyData?.createdAt ? moment(storedAssignedCompanyData?.createdAt).format('LLLL') : 'N/A'}
											</Text>
										</Flex>

										<Flex p={1} pl={2} pr={2} mt="2" _hover={{ bg: 'gray.200' }}>
											<Text fontWeight="bold" w="120px" minW="120px">
												{t('read date')}:
											</Text>
											<Text ml="4">
												{storedAssignedCompanyData?.firstReadAt ? moment(storedAssignedCompanyData?.firstReadAt).format('LLLL') : 'N/A'}
											</Text>
										</Flex>

										<Flex p={1} pl={2} pr={2} mt="2" _hover={{ bg: 'gray.200' }}>
											<Text fontWeight="bold" w="120px" minW="120px">
												{t('Due Date')}:
											</Text>
											<Text ml="4">
												{storedAssignedCompanyData?.dueAt ? moment(storedAssignedCompanyData?.dueAt).format('LLLL') : 'N/A'}
											</Text>
										</Flex>

										<Flex alignItems="center" mt="2" p={1} pl={2} pr={2} _hover={{ bg: 'gray.200' }}>
											<FileViewer label="Reply Letter" file={storedAssignedCompanyData?.replyLetter} labelWeight="bold" p={0} pl={0} />
										</Flex>

										<Flex alignItems="center" mt="2" p={1} pl={2} pr={2} _hover={{ bg: 'gray.200' }}>
											<FileViewer
												label="Supporting Document"
												file={storedAssignedCompanyData?.supportingDocument}
												labelWeight="bold"
												p={0}
												pl={0}
											/>
										</Flex>

										<Divider h="1px" mt="8" mb="8" />

										<Flex alignItems="center" p={1} pl={2} pr={2} mb={2} _hover={{ bg: 'gray.200' }}>
											<Text mr="4" fontWeight="500" minW={leftLabelWidth} w={leftLabelWidth}>
												{t('Applicant Note')}:
											</Text>

											<Tooltip
												shouldWrapChildren
												label={
													<>
														<Text color="white">
															{data?.getComplaintById?.complaintCategories === null ||
															data?.getComplaintById?.complaintCategories !== 'COMPLAINT_ON_DISPUTE_INSURANCE'
																? '•' +
																	t('Please pick a complaint category (Only Available for Complaint on Dispute Insurance)') +
																	'\n'
																: ''}
														</Text>
														<Text color="white">
															{data?.getComplaintById?.adminContactName === null ||
															data?.getComplaintById?.adminContactNumber === null
																? '•' + t('Please Fill in Contact Info')
																: ''}
														</Text>
														<Text color="white">
															{storedAssignedCompanyData?.replyLetter === null ||
															storedAssignedCompanyData?.replyLetter === undefined
																? '•' + t('Please Assign to Company and Wait for company reply letter')
																: ''}
														</Text>
														<Text color="white">
															{!data?.getComplaintById?.name || data?.getComplaintById?.name.trim() === ''
																? '•' + t('Please Fill in Applicant Name')
																: ''}
														</Text>
													</>
												}
												isDisabled={data?.getComplaintById?.applicantNote ? true : false}
											>
												<Box>
													<ApplicantNote
														disabled={
															!checkLastStatusCondition() ||
															!spamCheckTurnOffButtons() ||
															data?.getComplaintById?.name === null ||
															data?.getComplaintById?.name.trim() === '' ||
															data?.getComplaintById?.complaintCategories === null ||
															data?.getComplaintById?.complaintCategories !== 'COMPLAINT_ON_DISPUTE_INSURANCE' ||
															data?.getComplaintById?.adminContactName === null ||
															data?.getComplaintById?.adminContactNumber === null ||
															storedAssignedCompanyData?.replyLetter === null ||
															storedAssignedCompanyData?.replyLetter === undefined
																? true
																: false
														}
														id={id}
														companyId={storedAssignedCompanyData?.companyId}
														callback={() => {
															window.scrollTo(0, 0);
															setTimeout(() => {
																loadComplaint({
																	variables: {
																		id,
																	},
																});
															}, 500);
														}}
														existingNote={data?.getComplaintById?.applicantNote}
													/>
												</Box>
											</Tooltip>
										</Flex>

										<Flex alignItems="center" p={1} pl={2} pr={2} _hover={{ bg: 'gray.200' }}>
											<Text mr="2" fontWeight="500" minW={leftLabelWidth} w={leftLabelWidth}>
												{t('Reply Letter to Plaintiff')}:
											</Text>
											<Box>
												<UserReplyLetterFile
													id={id}
													callback={() => {
														window.scrollTo(0, 0);
														setTimeout(() => {
															loadComplaint({
																variables: {
																	id,
																},
															});
														}, 500);
													}}
													existingReplyLetterFile={data?.getComplaintById?.plaintiffReplyLetterFile}
													assignerNames={data?.getComplaintById?.plaintiffReplyLetterAssigner}
													disable={
														!checkLastStatusCondition() || !spamCheckTurnOffButtons() || enableApplicantReplyLetterCondition()
															? true
															: false
													}
													existingCategoryCheck={data?.getComplaintById?.complaintCategories}
													existingNoteCheck={data?.getComplaintById?.applicantNote}
												/>
											</Box>
										</Flex>

										<Flex alignItems="center" mt={2} p={1} pl={2} pr={2} _hover={{ bg: 'gray.200' }}>
											<Text fontWeight="500" w="120px" minW="120px">
												{t('Answer to Reply Letter')}:
											</Text>
											{getPlaintiffReplyStatus(data?.getComplaintById?.plaintiffResolutionAcceptance)}
										</Flex>

										<Flex alignItems="center" mt={2} p={1} pl={2} pr={2} _hover={{ bg: 'gray.200' }}>
											<Text fontWeight="500" w="120px" minW="120px">
												{t('Reason of Disagreement')}:
											</Text>
											<Text ml="5">
												{data?.getComplaintById?.resolutionDenialReason ? data?.getComplaintById.resolutionDenialReason : 'N/A'}
											</Text>
										</Flex>

										<Divider h="1px" mt="8" mb="8" />

										<Flex alignItems="center" p={1} pl={2} pr={2} _hover={{ bg: 'gray.200' }}>
											<Text mr="2" fontWeight="500" minW={leftLabelWidth} w={leftLabelWidth}>
												{t('Plaintiff Invitation Letter')}:
											</Text>
											<Box>
												<UploadPlaintiffInvitationLetter
													complaintId={id}
													callback={() => {
														window.scrollTo(0, 0);
														setTimeout(() => {
															loadComplaint({
																variables: {
																	id,
																},
															});
														}, 500);
													}}
													fileExist={data?.getComplaintById?.plaintiffInvitationLetter}
													// assignerNames={data?.getComplaintById?.plaintiffReplyLetterAssigner}
													disable={
														!checkLastStatusCondition() ||
														!spamCheckTurnOffButtons() ||
														applicantResponseILButtonCondition(data?.getComplaintById?.plaintiffResolutionAcceptance)
															? true
															: false
													}
													// existingCategoryCheck={data?.getComplaintById?.complaintCategories}
													// existingNoteCheck={data?.getComplaintById?.applicantNote}
												/>
											</Box>
										</Flex>

										<Flex alignItems="center" p={1} pl={2} pr={2} _hover={{ bg: 'gray.200' }}>
											<Text mr="2" fontWeight="500" minW={leftLabelWidth} w={leftLabelWidth}>
												{t('Company Invitation Letter')}:
											</Text>
											<Box>
												<UploadCompanyInvitationLetter
													complaintId={dataLoadAssignedCompany?.getExistingAssignedCompanyByComplaintId?.id}
													callback={() => {
														window.scrollTo(0, 0);
														setTimeout(() => {
															loadAssignedCompany({
																variables: {
																	complaintId: id,
																},
															});
															loadComplaint({
																variables: {
																	id,
																},
															});
														}, 500);
													}}
													fileExist={dataLoadAssignedCompany?.getExistingAssignedCompanyByComplaintId?.companyInvitationLetter}
													// assignerNames={data?.getComplaintById?.plaintiffReplyLetterAssigner}
													disable={
														!checkLastStatusCondition() ||
														!spamCheckTurnOffButtons() ||
														applicantResponseILButtonCondition(data?.getComplaintById?.plaintiffResolutionAcceptance) ||
														storedAssignedCompanyData === null
															? true
															: false
													}
													// existingCategoryCheck={data?.getComplaintById?.complaintCategories}
													// existingNoteCheck={data?.getComplaintById?.applicantNote}
												/>
											</Box>
										</Flex>

										<Divider h="1px" mt="8" mb="8" />

										<Flex alignItems="center" p={1} pl={2} pr={2} _hover={{ bg: 'gray.200' }}>
											<Text fontWeight="500" minW={leftLabelWidth} w={leftLabelWidth}>
												{t('Done')}:
											</Text>
											{data?.getComplaintById?.settled ? (
												<>
													{data?.getComplaintById?.doneFile ? (
														<Box>
															<DownloadAndViewButton
																url={data?.getComplaintById?.doneFile?.file}
																size={data?.getComplaintById?.doneFile?.fileSize}
															/>
														</Box>
													) : (
														<Text ml={2}>N/A</Text>
													)}
												</>
											) : (
												<>
													{currentUser?.role === 'admin' || currentUser?.canUploadDoneFileToComplaint ? (
														<Box>
															<DoneFileUplaod
																id={id}
																callback={() => {
																	window.scrollTo(0, 0);
																	setTimeout(() => {
																		loadComplaint({
																			variables: {
																				id,
																			},
																		});
																	}, 500);
																}}
															/>
														</Box>
													) : (
														<Text ml={2}>N/A</Text>
													)}
												</>
											)}
										</Flex>
									</Box>
								)}
							</Box>
						</Center>
						{data?.getComplaintById?.id && <ViewComment id={data?.getComplaintById?.id} type="COMPLAINT" />}
					</Container>

					{selectUserModalOpen && (
						<SelectUserModal
							role="complaint"
							callback={selectAssignUser}
							isOpen={selectUserModalOpen}
							onClose={() => setSelectUserModalOpen(false)}
						/>
					)}

					<AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
						<AlertDialogOverlay>
							<AlertDialogContent>
								<AlertDialogHeader fontSize="lg" fontWeight="bold">
									{t('Remove Assigned User')}
								</AlertDialogHeader>

								<AlertDialogBody>
									{t(`Are you sure you want to remove`)} "{getDisplayName(removingUserId)}"?
								</AlertDialogBody>

								<AlertDialogFooter>
									<Button ref={cancelRef} onClick={onClose}>
										{t('Cancel')}
									</Button>
									<Button
										isLoading={loadingRemove}
										colorScheme="red"
										onClick={() => {
											removeUserMutation({
												variables: {
													id: id,
													userId: removingUserId?.id,
												},
											});
										}}
										ml={3}
									>
										{t('Remove')}
									</Button>
								</AlertDialogFooter>
							</AlertDialogContent>
						</AlertDialogOverlay>
					</AlertDialog>

					<AlertDialog isOpen={openRemoveCompanyBox} leastDestructiveRef={cancelRef} onClose={hideRemoveCompanyBox}>
						<AlertDialogOverlay>
							<AlertDialogContent>
								<AlertDialogHeader fontSize="lg" fontWeight="bold">
									{t('Remove Assigned Company')}
								</AlertDialogHeader>

								<AlertDialogBody>
									{t(`Are you sure you want to remove`)} "
									{currentLang === 'en'
										? dataAssignedCompany?.getAssigedCompanyByCompanyId?.name
										: dataAssignedCompany?.getAssigedCompanyByCompanyId?.nameKhmer}
									"?
								</AlertDialogBody>

								<AlertDialogFooter>
									<Button ref={cancelRef} onClick={hideRemoveCompanyBox}>
										{t('Cancel')}
									</Button>
									<Button
										isLoading={loadingRemoveAssignedCompany}
										colorScheme="red"
										onClick={() => {
											const existingId = getIdForAssignedCompanyRemoval();
											removeAssignedCompanyById({
												variables: {
													id: existingId,
												},
											});
											hideRemoveCompanyBox();
											setStoredAssignedCompanyData(null);
										}}
										ml={3}
									>
										{t('Remove')}
									</Button>
								</AlertDialogFooter>
							</AlertDialogContent>
						</AlertDialogOverlay>
					</AlertDialog>

					<CModal isOpen={contactInfoModal} onClose={closeContactInfoModal} size="xl">
						<ModalOverlay />
						<ModalContent>
							<ModalHeader>{t('ContactInfo')}</ModalHeader>
							<ModalCloseButton />
							<ModalBody>
								<Table variant="simple">
									<Thead>
										<Tr>
											<Th>{t('Full Name In Khmer')}</Th>
											<Th>{t('Phone Number')}</Th>
										</Tr>
									</Thead>
									<Tbody>
										{data?.getComplaintById?.employeesContactInfo?.length > 0 ? (
											data?.getComplaintById?.employeesContactInfo.map((user, index) => {
												return (
													<Tr
														key={`user-${index}`}
														cursor="pointer"
														_hover={{ backgroundColor: 'gray.200' }}
														onClick={() => {
															// console.log('clicked', user?.fullName, user?.phoneNumber);
															setStoredContactName(user?.fullName ?? '');
															setStoredContactPhoneNumber(user?.phoneNumber ?? '');
														}}
													>
														<Td color="#2980b9" fontWeight="500">
															{user?.fullName ? user?.fullName : 'N/A'}
														</Td>
														<Td color="#2980b9" fontWeight="500">
															{user?.phoneNumber ? user?.phoneNumber : 'N/A'}
														</Td>
													</Tr>
												);
											})
										) : (
											<Tr>
												<Td py={4} color="gray.500">
													N/A
												</Td>
												<Td py={4} color="gray.500">
													N/A
												</Td>
											</Tr>
										)}
									</Tbody>
									<Tfoot>
										<Tr>
											<Th>{t('Full Name In Khmer')}</Th>
											<Th>{t('Phone Number')}</Th>
										</Tr>
									</Tfoot>
								</Table>
								<Divider h="1px" mt="6" mb="8" />
								<ContactInfoInput
									label="Officer Name"
									value={storedContactName}
									onChange={(e) => {
										setStoredContactName(e);
									}}
									lastChanged={data?.getComplaintById?.adminContactName}
									disabled={storedAssignedCompanyData !== null || !checkLastStatusCondition() || !spamCheckTurnOffButtons() ? true : false}
									loading={contactInfoSaveLoading}
								/>

								<ContactInfoInput
									label="Contact Phone number"
									value={storedContactPhoneNumber}
									onChange={(e) => {
										setStoredContactPhoneNumber(e);
									}}
									lastChanged={data?.getComplaintById?.adminContactNumber}
									disabled={storedAssignedCompanyData !== null || !checkLastStatusCondition() || !spamCheckTurnOffButtons() ? true : false}
									loading={contactInfoSaveLoading}
								/>
							</ModalBody>

							<ModalFooter>
								<Button
									loading={contactInfoSaveLoading}
									disabled={
										contactInfoSaveLoading ||
										storedAssignedCompanyData !== null ||
										!checkLastStatusCondition() ||
										!spamCheckTurnOffButtons() ||
										storedContactPhoneNumber === null ||
										storedContactPhoneNumber?.trim() === '' ||
										storedContactName === null ||
										storedContactName?.trim() === ''
											? true
											: false
									}
									mb={2}
									mt={2}
									ml={2}
									width="auto"
									color="#3498DA"
									onClick={async () => {
										await saveContactInfo({
											variables: {
												id,
												adminContactName: storedContactName,
												adminContactNumber: storedContactPhoneNumber,
											},
										});
										closeContactInfoModal();
									}}
								>
									{t('Save')}
								</Button>
							</ModalFooter>
						</ModalContent>
					</CModal>

					<NModal isOpen={applicantNameModal} onClose={closeApplicantNameModal} size="xl">
						<ModalOverlay />
						<ModalContent>
							{/* <ModalHeader>{t('Applicant Name on Note')}</ModalHeader> */}
							<ModalCloseButton />
							<ModalBody mt="50px">
								<ContactInfoInput
									label="Name"
									value={applicantName}
									onChange={(e) => {
										setApplicantName(e);
									}}
									lastChanged={data?.getComplaintById?.name}
									disabled={!checkLastStatusCondition() || !spamCheckTurnOffButtons() ? true : false}
									loading={loadingApplicantname}
								/>
							</ModalBody>

							<ModalFooter>
								<Button
									loading={loadingApplicantname}
									disabled={
										loadingApplicantname ||
										!checkLastStatusCondition() ||
										!spamCheckTurnOffButtons() ||
										applicantName === null ||
										applicantName?.trim() === '' ||
										data?.getComplaintById?.applicantNote !== null
											? true
											: false
									}
									mb={2}
									mt={2}
									ml={2}
									width="auto"
									color="#3498DA"
									onClick={async () => {
										await saveApplicantName({
											variables: {
												id,
												name: applicantName,
											},
										});
										closeApplicantNameModal();
									}}
								>
									{t('Save')}
								</Button>
							</ModalFooter>
						</ModalContent>
					</NModal>

					<AlertDialog
						onEsc={closeAssignCompanyConfirmationBox}
						isOpen={assignCompanyConfirmationBox}
						leastDestructiveRef={cancelRef}
						onClose={closeAssignCompanyConfirmationBox}
					>
						<AlertDialogOverlay>
							<AlertDialogContent>
								<AlertDialogHeader fontSize="lg" fontWeight="bold">
									{t('Confirm Company Assignment')}
								</AlertDialogHeader>

								<AlertDialogBody>
									{t(`Are you sure you want to assign this complaint to this company?`)}
									<Flex flexDirection="column" mt="4">
										<Image
											// maxW="70px"
											maxH="40px"
											h="auto"
											w="auto"
											src={c.baseFilePath + assginedCompnayConfirmationData?.logo}
											alt={`${assginedCompnayConfirmationData?.name} - ${assginedCompnayConfirmationData?.nameKhmer}`}
											objectFit="contain"
											fallbackSrc="/files/images/no-logo.png"
										/>
										<Text mt={2} textAlign="center">
											{currentLang === 'en' ? assginedCompnayConfirmationData?.name : assginedCompnayConfirmationData?.nameKhmer}
										</Text>
									</Flex>
								</AlertDialogBody>

								<AlertDialogFooter>
									<Button colorScheme="red" ref={cancelRef} onClick={closeAssignCompanyConfirmationBox}>
										{t('Cancel')}
									</Button>
									<Button
										colorScheme="blue"
										onClick={() => {
											setCompanyInfo(assginedCompnayConfirmationData);
											closeAssignCompanyConfirmationBox();
										}}
										ml={3}
									>
										{t('Confirm')}
									</Button>
								</AlertDialogFooter>
							</AlertDialogContent>
						</AlertDialogOverlay>
					</AlertDialog>

					{companyAssignModal && (
						<Modal
							companyType={null}
							isOpen={true}
							onClose={companyAssignModalClose}
							onCallback={(e) => {
								setAssginedCompnayConfirmationData(e);
								openAssignCompanyConfirmationBox();
							}}
						/>
					)}
				</>
			</PrintLayout>
			{(loadingAssignCompany || loadingLoadAssignedCompany || loadingUpdateStatus) && <LoadingOverlay />}
		</>
	);
}

export default NewComplaintDetail;
